import numberToSubscriptString from './numberToSubscriptString';

function collapseZeros(value: number | undefined): string {
  if (!value) {
    return '';
  }

  const valueAsString = value.toFixed(18);

  if (!valueAsString.includes('.')) {
    return valueAsString;
  }

  const splittedValue = valueAsString.split('.');

  const decimals = splittedValue[1];

  const zerosSequenceRegExp = /0(0{2,})/g;
  const match = zerosSequenceRegExp.exec(decimals);

  if (!match || !match[1]) {
    return valueAsString;
  }

  return [
    splittedValue[0],
    '.',
    decimals.substring(0, match.index + 1),
    numberToSubscriptString(match[1].length),
    decimals.substring(zerosSequenceRegExp.lastIndex),
  ]
    .join('')
    .replace(/0+$/,'');
}

export default collapseZeros;
